import compose from "ramda/es/compose";
import equals from "ramda/es/equals";
import identity from "ramda/es/identity";
import isNil from "ramda/es/isNil";
import pathOr from "ramda/es/pathOr";
import prop from "ramda/es/prop";
import propOr from "ramda/es/propOr";
import toLower from "ramda/es/toLower";
import unless from "ramda/es/unless";
import isNilOrEmpty from "ramda-extension/es/isNilOrEmpty";
import { createSelector } from 'reselect';
import { getAccessToken, getDecodedAccessToken, getUserLogon } from '@gef-ui/redux-common/selectors/appContext';
import { COMPANY_NUM, REDUCER_NAME } from '../constants';
import { getDelegationCookies, resolveDelegationUser } from '../utils';
const delegations = prop(REDUCER_NAME);
export const getDelegations = createSelector(delegations, propOr([], 'delegation'));
export const getRepresentedUserLogin = createSelector(getUserLogon, (userLoginFromToken)=>{
    resolveDelegationUser(userLoginFromToken);
    const delegationFromCookie = getDelegationCookies();
    if (isNilOrEmpty(delegationFromCookie?.representativeFor)) {
        return '';
    }
    if (equals(toLower(delegationFromCookie?.representativeFor), toLower(userLoginFromToken))) {
        return '';
    } else {
        return delegationFromCookie.representativeFor;
    }
}, {
    memoize: identity
});
export const getCompanyIdFromToken = createSelector((state)=>isNilOrEmpty(getAccessToken(state)) ? null : getDecodedAccessToken(state), compose(unless(isNil, parseInt), pathOr(null, [
    'token_details',
    'companyId'
])));
export const getCompanyFromToken = createSelector(getCompanyIdFromToken, (companyId)=>propOr(null, companyId, COMPANY_NUM));
export const getOriginalUserLoginFromToken = createSelector((state)=>isNilOrEmpty(getAccessToken(state)) ? null : getDecodedAccessToken(state), pathOr(null, [
    'token_details',
    'originalUserLogin'
]));
